export default "/assets/images/prosv-logo.png"